import { Injectable } from '@angular/core';
import { DialogService, DynamicDialogRef } from 'primeng/dynamicdialog';
import { UpdatePasswordComponent } from '../components/update-password/update-password.component';

// export interface IPopupActions<T> {
//   popupRef: MatDialogRef<T>;
//   // tslint:disable-next-line:ban-types
//   show(successCallback: Function): void;
//   close(): void;
// }


@Injectable({
  providedIn: 'root'
})
export class ForgotPasswordService {

  constructor(
    public dialogService: DialogService,
    public popupRef: DynamicDialogRef
  ) { }

  // tslint:disable-next-line:ban-types
  show(successCallback: Function = null): void {
   

    const dialogRef = this.dialogService.open(UpdatePasswordComponent, {
      data: {
        onSuccess: () => {
          if (successCallback) {
            successCallback();
          }
        }
      },
      showHeader: false

    });

    // this.popupRef = this.dialog.open(UpdatePasswordComponent, {
    //   data: {
    //     onSuccess: () => {
    //       if (successCallback) {
    //         successCallback();
    //       }
    //     }
    //   }
    // });
  }

  close(): void {
    if (this.popupRef) {
      this.popupRef.close();
    }
  }
}
